import {Component} from '@angular/core';

@Component({
    selector: 'search-email-loader',
    templateUrl: './search-email-loader.component.html',
    styleUrls: ['./search-email-loader.component.scss']
})
export class SearchEmailLoaderComponent {
}
